export var ToasterAlertPosition;
(function (ToasterAlertPosition) {
    ToasterAlertPosition["TOP"] = "top";
    ToasterAlertPosition["BOTTOM"] = "bottom";
})(ToasterAlertPosition || (ToasterAlertPosition = {}));
export var ToasterAlertFloat;
(function (ToasterAlertFloat) {
    ToasterAlertFloat["RIGHT"] = "right";
    ToasterAlertFloat["LEFT"] = "left";
})(ToasterAlertFloat || (ToasterAlertFloat = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQWxlcnRQcm9wcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL2NvbXBvbmVudHMvYWxlcnQvQWxlcnRQcm9wcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFVQSxNQUFNLENBQU4sSUFBWSxvQkFHWDtBQUhELFdBQVksb0JBQW9CO0lBQzlCLG1DQUFXLENBQUE7SUFDWCx5Q0FBaUIsQ0FBQTtBQUNuQixDQUFDLEVBSFcsb0JBQW9CLEtBQXBCLG9CQUFvQixRQUcvQjtBQUNELE1BQU0sQ0FBTixJQUFZLGlCQUdYO0FBSEQsV0FBWSxpQkFBaUI7SUFDM0Isb0NBQWUsQ0FBQTtJQUNmLGtDQUFhLENBQUE7QUFDZixDQUFDLEVBSFcsaUJBQWlCLEtBQWpCLGlCQUFpQixRQUc1QiJ9